import React from 'react';
import { useLocation } from 'react-router-dom';

import {
  matchOnboardingRoute,
  matchOnboardingEditReportUrl,
  matchOnboardingReportingUrl
} from '@futrli/shared-services';

import { Navbar } from './navbar/navbar';
import { useOrganisationManagementRoutes } from '../hooks/useOrganisationManagementRoutes';

export const PredictOrganisationNavbar = () => {
  const { routes } = useOrganisationManagementRoutes();
  const { pathname } = useLocation();
  const isOnboardingPage =
    matchOnboardingRoute(pathname) || matchOnboardingReportingUrl(pathname) || matchOnboardingEditReportUrl(pathname);
  const subNavRoutes = isOnboardingPage ? [] : routes;

  return <Navbar routes={subNavRoutes} />;
};
